<template>
  <div class="slide-header colorSlider">
    <div class="avatar" :style="{ 'background-image': ImageUrl }" @click="$router.push('/change-picture-request')"></div>
    <div class="name">
      <template v-if="userActive">
        {{ fullName }}
        <br />
        {{ NumSystem }}
      </template>
      <template v-else>
        <br />
        {{ fullName }}
        <br />
      </template>
    </div>
    <v-btn
      class="login-button"
      color="red white--text"
      @click="handleLogin"
      rounded
      >{{ buttonTitle }}</v-btn
    >
  </div>
</template>

<script>
import { getToken, logout } from "@/utils/auth";
export default {
  computed: {
    fullName() {
      return this.$store.getters.FullName;
    },
    NumSystem() {
      var num = this.$store.getters.NumSystem;
      return num != "" ? "کد طلبگی:  " + num : "";
    },
    buttonTitle() {
      return this.$store.getters.token != "" ? "خروج" : "ورود";
    },
    ImageUrl() {
      if (this.$store.getters.ImageUrl != "") {
        return "url(" + this.$store.getters.ImageUrl + ")";
      } else return "../assets/avatar.jpg";
    },
    userActive() {
      return this.$store.getters.userInfo.Active;
    },
  },
  methods: {
    /**
     * logout/ login
     */
    handleLogin() {
      logout();
    },
  },
};
</script>
<style>
.name {
  position: absolute;
  top: 60px;
  right: 100px;
  font-size: 15px;
}

.slide-header {
  display: block !important;
  /* background-image: url("../../assets/newback.png"); */

  padding: 5px 15px 50px 15px !important;
  color: white;
  height: 165px;
  width: 300px;
  position: sticky;
  top: 0px;
  z-index: 1;
}

.login-button {
  float: left;
  top: 115px;
  left: 10px;
  height: 32px !important;
}

.avatar {
  width: 70px;
  height: 84px;
  float: right;
  margin: 15px 0px;
  background-size: 100%;
  border-radius: 6px;
  cursor: pointer;
}
</style>
